import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { GlobalService } from 'app/service/globalService';
@Component({
  selector: 'app-re-login',
  templateUrl: './re-login.component.html',
  styleUrls: ['./re-login.component.css']
})
export class ReLoginComponent implements OnInit {

  constructor(private oauthService: OAuthService, private globalService: GlobalService) { }

  ngOnInit(): void {
    console.log('ReLoginComponent ngOnInit');
    this.globalService.setLoadingOff();
   // this.reLogin();
  }
  public reLogin(): void {    
    this.globalService.setLoadingOn();
    // setTimeout(() => {
    //   this.oauthService.initLoginFlow();
    // }, 10000);
    window.location.reload()
  }
}
